export const currentUser = (state) => state.currentUser;
export const userEmail = (state) => state.userEmail;
export const permissions = (state) => state.permissions;
export const authenticated = (state) => state.authenticated;
export const token = (state) => state.token;
